import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const Manga = () => {
    const IMGPATH = "https://cdn.discordapp.com/attachments/";
    const [ChaptersFiltred, setChaptersFiltred] = useState([]);
    const [MangaFiltred, setMangaFiltred] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mainloading, setmainLoading] = useState(true);
    let numb = 0;
    let { id } = useParams();

    /* Sending data to useState to use it on page*/
    useEffect(() => {
        const getManga = async () => {
            await fetchManga();
        };
        getManga();
    }, []);

    /* Fetching from a URL data */
    const fetchManga = async () => {
        const resmain = await fetch("../gu1v2.json", {
            headers: {
                "Access-Control-Allow-Origin": "application/json",
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const datamain = await resmain.json();
        const resultmain = datamain.data.filter((item) => {
            return item.id.toString() === id;
        });
        setMangaFiltred(...resultmain);
        setmainLoading(false);
        const res = await fetch("../gu1.json", {
            headers: {
                "Access-Control-Allow-Origin": "application/json",
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const data = await res.json();
        const result = data.data.filter((item) => {
            return item.id.toString() === id;
        });
        setChaptersFiltred(...result);
        setLoading(false);
    };

    const ChangePage = (e) => {
        window.location.href = "/mangi/" + id + "/" + e.target.value;
    };

    return (
        <>
            {mainloading === false && (
                <div className="Main-center-flex">
                    <div className="glowna1">
                        <div className="prawo-sec">
                            <>
                                <h3>{MangaFiltred.overview}</h3>
                            </>
                        </div>
                        <div className="prawo-thir">
                            {loading === false && (
                                <select className="Select-chapter" defaultValue={"default"} onChange={ChangePage}>
                                    <option value="default" disabled>
                                        Select Chapter
                                    </option>
                                    {ChaptersFiltred.chapters.map((chap) => (
                                        <option key={chap.id} value={chap.id}>
                                            {chap.title}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className="prawo-fir">
                        <div className="glowna1">
                            <img src={IMGPATH + MangaFiltred.photo_path} alt={MangaFiltred.title} />
                            <h3>{MangaFiltred.title}</h3>
                            <h5>Data Wydania: {MangaFiltred.release_date} </h5>
                            <h5>Status : {MangaFiltred.status}</h5>
                            <h5>Typ: {MangaFiltred.type}</h5>
                            {MangaFiltred.status === "Completed" && <h5>Chaptery : {MangaFiltred.Amount_Chapters} </h5>}
                            <h5>
                                Genres:
                                <ul>{MangaFiltred.genre.map((gen) => (gen !== "" ? <li key={(numb += 1)}>{gen}</li> : gen))}</ul>
                            </h5>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Manga;
